import {
  httpsCallable,
  type HttpsCallableResult,
  type HttpsCallableOptions,
} from 'firebase/functions';

import { functions } from '@src/firebase/firebase';

import type { ApiOperation } from './operations';

const API_FUNCTION_NAME = 'api';

interface ApiClientInfo {
  app: 'web';
  version?: string;
}

interface ApiEnvelope<TPayload> {
  op: ApiOperation;
  payload?: TPayload;
  client: ApiClientInfo;
}

const getClientInfo = (): ApiClientInfo => {
  const version =
    typeof SYSTEM !== 'undefined' && typeof SYSTEM.version === 'string'
      ? SYSTEM.version
      : undefined;

  return {
    app: 'web',
    ...(version ? { version } : {}),
  };
};

export const apiCallable = <TPayload = unknown, TResult = unknown>(
  op: ApiOperation,
  options?: HttpsCallableOptions,
): ((payload?: TPayload) => Promise<HttpsCallableResult<TResult>>) => {
  const callApi = options
    ? httpsCallable<ApiEnvelope<TPayload>, TResult>(functions, API_FUNCTION_NAME, options)
    : httpsCallable<ApiEnvelope<TPayload>, TResult>(functions, API_FUNCTION_NAME);

  return async (payload?: TPayload): Promise<HttpsCallableResult<TResult>> => {
    const envelope: ApiEnvelope<TPayload> = {
      op,
      ...(payload === undefined ? {} : { payload }),
      client: getClientInfo(),
    };

    return callApi(envelope);
  };
};
